import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {HttpCommonService} from "../../services/http-common.service";

import '../../../assets/plugins/echarts/dist/echarts2.js';
import {EnterpAtlasService} from "../../services/enterp-atlas.service";
declare var echartsEC: any;
/**
 * 关联链图
 */
@Component({
  selector: 'app-enter-association-chain-graph',
  templateUrl: './enter-association-chain-graph.component.html',
  styleUrls: ['./enter-association-chain-graph.component.css']
})
export class EnterAssociationChainGraphComponent implements OnInit {

  //关联链图
  myChartLink: any;
  nodes: any;
  links: any;
  eNodes: any;
  eLinks: any;
  shapeList: any;
  onNode: any;
  fullOffX: any;
  fullOffY: any;
  //传递的参数 企业ID
  companyId: string;
  constructor(private routerInfo: ActivatedRoute, private httpService: HttpCommonService,
              private enterService: EnterpAtlasService) {
    this.companyId = routerInfo.snapshot.queryParams['companyId'];
    // this.companyId = "00001e0dc8082237c287be3db76761ca";
  }

  ngOnInit() {
    // this.getLinkData();
  }
  //获取数据
  getLinkData() {
    if (this.companyId) {
      this.myChartLink = echartsEC.init(document.getElementById('chainGraph'));
      this.httpService.get('/enterprise/detail/xhsRest/enterMap/getLinkDatas',
        {companyId: this.companyId}).subscribe(result => {
        console.log(result);
        if (result.stateCode == "60601") {
          this.drawDatas(result.data);
        }
      });
    }
  }
  //处理后台数据
  drawDatas(data: any) {
    this.nodes = [];
    this.links = [];
    let width = $('#chainGraph').width();
    let height = $('#chainGraph').height();
    let centerX = width/2;
    let centerY = height/2;
    let personRadius = 100;//半径
    let companyRadius = 270;
    let personAngle = 270;//角度
    let companyAngle = 270;
    let companyCount = 0;//个数
    let personCount = 0;
    let companyIndex = 0;
    let personIndex = 0;//计数
    let companyLevel = 1;//等级
    $.each(data.Nodes,function(i,node){
      if(node.Category==1){
        companyCount++;
      }else if(node.Category==2){
        personCount++;
      }
    });
    let personAngleOff = 360/personCount;//夹角
    let tempRadius = 100;
    if(personCount > 12){
      personAngleOff = 360/12;
      let num = 0;
      for(let i = 0;i<20;i++){
        num += (12 + 9 * i);
        if(num < personCount){
          tempRadius += 70;
        }
      }
    }
    let companyAngleOff = 360/34;
    if(tempRadius > 100){
      companyRadius = tempRadius + 90;
    }
    if(companyCount > 95){
      companyLevel = 5;
      companyAngleOff = 360/13;
      companyRadius = 180;
    }else if(companyCount > 61 && companyCount <= 95){
      companyLevel = 4;
      companyAngleOff = 360/34;
      companyRadius = 450;
    }else if(companyCount > 34 && companyCount <= 61){
      companyLevel = 3;
      companyAngleOff = 360/27;
      companyRadius = 360;
    }else if(companyCount > 21 && companyCount <= 34){
      companyLevel = 2;
      companyAngleOff = 360/20;
    }else if(companyCount <= 21){
      companyLevel=1;
      companyAngleOff = 360/companyCount;
    }
    let thiss = this;
    $.each(data.Nodes,function(i,node){
      let color = '#40bfd5';//公司 2ec7c9
      let symbolSize = 37;
      let fixX = true;
      let fixY = true;
      let x;
      let y;
      if(node.Category == 1){//圆周运动
        x = centerX + Math.sin(companyAngle * Math.PI/180) * companyRadius;
        y = centerY + Math.cos(companyAngle * Math.PI/180) * companyRadius;
        companyAngle += companyAngleOff;
        companyIndex ++;
        if(companyLevel == 1){

        }else if(companyLevel == 2){
          if(companyIndex == 20){
            companyRadius -= 90;
            companyAngle = 0;
            companyAngleOff = 360/(companyCount - 20);
          }
        }else if(companyLevel == 3){
          if(companyIndex == 27){
            companyRadius -= 90;
            companyAngle = 0;
            if((companyCount - 27) > 21){
              companyAngleOff = 360/20;
            }else{
              companyAngleOff = 360/(companyCount - 27);
            }
          }
          if((companyCount - 27) > 21 && companyIndex == 47){
            companyRadius -= 90;
            companyAngle = 0;
            companyAngleOff = 360/(companyCount - 47);
          }
        }else if(companyLevel == 4){
          if(companyIndex == 34){
            companyRadius -= 90;
            companyAngle = 0;
            if((companyCount - 34) > 28){
              companyAngleOff = 360/27;
            }else{
              companyAngleOff = 360/(companyCount - 34);
            }
          }
          if((companyCount - 34) > 28 && companyIndex == 61){
            companyRadius -= 90;
            companyAngle = 0;
            if((companyCount - 61) > 21){
              companyAngleOff = 360/20;
            }else{
              companyAngleOff = 360/(companyCount - 61);
            }
          }
          if((companyCount - 61) > 21 && companyIndex == 81){
            companyRadius -= 90;
            companyAngle = 0;
            companyAngleOff = 360/(companyCount - 81);
          }
        }else if(companyLevel == 5){
          for(let i = 0;i < 20;i ++){
            if((13 + 13 + i * 7) * (i + 1)/2 == companyIndex){
              companyRadius += 90;
              if(companyCount - companyIndex > 13 + (i + 1) * 7){
                companyAngleOff = 360/(13 + (i + 1) * 7);
              }else{
                companyAngleOff = 360/(companyCount - companyIndex);
              }
            }
          }
        }
      }else if(node.Category == 2){
        color="#6c89cb";//31e0b9  2aaedc 2fb1e3  人
        symbolSize = 25;
        fixX = false;
        fixY = false;
        x = centerX + Math.sin(personAngle * Math.PI/180) * personRadius;
        y = centerY + Math.cos(personAngle * Math.PI/180) * personRadius;
        personAngle += personAngleOff;
        personIndex ++;
        if(personCount > 10){
          for(let i = 0;i < 20;i ++){
            if((12 + 12 + i * 9) * (i + 1)/2 == personIndex){
              personRadius += 70;
              if(personCount - personIndex > 12 + (i + 1) * 9){
                personAngleOff = 360/(12 + (i + 1) * 9);
              }else{
                personAngleOff = 360/(personCount - personIndex);
              }
            }
          }
        }
      }
      thiss.nodes.push({
        name:  node.Name, //节点名称
        keyNo: node.Name, //标识
        initial: [x,y], //强制指定节点的初始值
        fixX: true,//是否固定
        fixY: true,
        category: node.Category, //节点的 category index
        label: node.Name.replace(/(.{5})(?=.)/g, '$1\n'), //名称过长换行 //节点标签名称
        //symbol : 'image://../../images/screenBG.jpg', //背景
        symbolSize: symbolSize, //强制指定节点的大小
        itemStyle: {
          normal: {
            color:color,
          },
        }
      });
    });
    $.each(data.Links,function(i,link){
      for(let i = 0;i < thiss.links.length;i ++){
        if(thiss.links[i].source == link.Source && thiss.links[i].target == link.Target){
          return;
        }
      }
      thiss.links.push({
        source : link.Source, //源节点
        target : link.Target, //目标节点
        name : link.Relation, //关系
        weight : 1, //边的权重
        itemStyle:{
          normal:{
            text:link.Relation,
            textColor:'#999',
            textFont:'normal 12px 微软雅黑',
            textPosition:'inside'
          }
        }
      });
    });
    //初始化图谱
    this.drawChartRelation(this.nodes,this.links);
  }
  //将企业、任务、关系生成图谱
  drawChartRelation(nodes,links) {
    var thiss = this;
    // requireEcharts.config({
    //   paths: {
    //     echarts: '../../../assets/plugins/echarts/dist'
    //   }
    // });
    // requireEcharts(
    //   [
    //     'echarts',
    //     'echarts/chart/force'
    //   ],
    //   function (ec) {
        //this.myChartLink = echartsEC.init(document.getElementById('chainGraph'));
        this.myChartLink.setOption({
          tooltip : {
            show: false,
            trigger: 'item',
            formatter: '{b}'
          },
          animation: true,
          series : [
            {
              type:'force',
              name : "关联分析",
              ribbonType: false,
              linkSymbol:'arrow',
              linkSymbolSize:[10, 10], //对箭头的控制力导向图的边两端图形大小
              large:true,
              useWorker: true, //是否在浏览器支持 web worker 的时候把布局计算放入 web worker 中
              steps:10, //每一帧布局计算的迭代次数
              roam: true, //是否开启滚轮缩放和拖拽漫游
              itemStyle: {
                normal: {
                  label: {
                    show: true,
                    textStyle: {
                      color: '#fff'
                    }
                  },
                  nodeStyle : {
                    brushType : 'both',
                    borderColor : '#dfdfdf',
                    borderWidth : 0
                  },
                  linkStyle: {
                    color: '#ddd'
                  }
                },
                emphasis: {
                  label: {
                    show: false
                  },
                  nodeStyle : {
                    brushType : 'both',
                    borderColor : '#dfdfdf',
                    borderWidth : 4
                  },
                  linkStyle : {}
                }
              },
              nodes:nodes,
              links:links
            }
          ]
        });
        thiss.initZrender();
        thiss.animatieChartLink(thiss.myChartLink,0,0);
        //let ecConfig = requireEcharts('echarts/config');
        //thiss.myChartLink.on(ecConfig.EVENT.RESTORE, function(param){
        thiss.myChartLink.on('restore', function(param){
          thiss.initZrender();
          /*if(isFullScreen){
            thiss.animatieChartLink(thiss.myChartLink,thiss.fullOffX,thiss.fullOffY);
          }else{
            thiss.animatieChartLink(thiss.myChartLink,0,0);
          }*/
          thiss.animatieChartLink(thiss.myChartLink,0,0);
        });
        thiss.myChartLink.on('click', function(param){
          let hoverNode = param.value;
          for(let i=0;i<thiss.eNodes.length;i++){
            thiss.eNodes[i].style.lineWidth = 0;
            thiss.eNodes[i].z = 2;
          }
          for(let i=0;i<thiss.eLinks.length;i++){
            thiss.eLinks[i].style.textColor='#999';
            thiss.eLinks[i].style.strokeColor='#ddd';
            thiss.eLinks[i].style.textFont='normal 12px 微软雅黑';
            thiss.eLinks[i].arrow.style.color = '#ddd';
            thiss.eLinks[i].z = 2;
            thiss.eLinks[i].arrow.z = 2;
          }
          if(thiss.onNode!=hoverNode&&hoverNode.keyNo){
            for(let i=0;i<thiss.eLinks.length;i++){
              let edata = thiss.eLinks[i]._echartsData._data;
              if(edata.source==hoverNode.name||edata.target==hoverNode.name){
                thiss.eLinks[i].style.textColor = '#00457d';
                thiss.eLinks[i].style.strokeColor="#005fac";
                thiss.eLinks[i].style.textFont="bold 12px 微软雅黑";
                thiss.eLinks[i].arrow.style.color="#005fac";
                thiss.eLinks[i].z = 5;
                thiss.eLinks[i].arrow.z = 5;
                for(let j=0;j<thiss.eNodes.length;j++){
                  let edata1 = thiss.eNodes[j]._echartsData._data;
                  if(edata1.keyNo==edata.source||edata1.keyNo==edata.target){
                    thiss.eNodes[j].style.lineWidth = 4;
                    thiss.eNodes[j].z = 6;
                  }
                }
              }
            }
            thiss.onNode = hoverNode;
          }else{
            thiss.onNode = '';
          }
          thiss.myChartLink.getZrender().refreshShapes(thiss.shapeList,function(){});//更新视图
        });
        window.onresize=function(){
          thiss.myChartLink.resize();
        }
      //}
    //);
  }
  //初始化箭头指向   ->从根节点删除图形
  initZrender(){
    this.eNodes = [];
    this.eLinks = [];
    this.shapeList = this.myChartLink.getZrender().storage.getShapeList();
    for(let i=0;i<this.shapeList.length;i++){
      if(this.shapeList[i]._echartsData && this.shapeList[i]._echartsData._data){
        let edata = this.shapeList[i]._echartsData._data;
        if(edata.keyNo){
          this.eNodes.push(this.shapeList[i]);
        }else{
          this.shapeList[i].arrow = this.shapeList[i+1];
          this.eLinks.push(this.shapeList[i]);
        }
      }
      if(this.shapeList[i].fullscreenMove){
        this.myChartLink.getZrender().delShape(this.shapeList[i].id);
      }
    }
  }
//更新关系指向   ->视图更新
  animatieChartLink(myChartLink,targetX,targetY) {
    let thiss = this;
    var centerX = myChartLink.getZrender().getWidth()/2;
    var centerY = myChartLink.getZrender().getHeight()/2;
    var layer = myChartLink.getZrender().painter._layers[1];
    var animation = myChartLink.getZrender().animation;
    layer.scale = [0.0001,0.0001,centerX,centerY];
    layer.rotation = [0,centerX,centerY];
    layer.position = [targetX||0,targetY||0];
    myChartLink.getZrender().painter.refresh();
    animation.animate(layer).when(400, {
      scale: [1,1,centerX,centerY]
    }).start('spline').done(function(){
      layer.scale[2] = 0;
      layer.scale[3] = 0;
    });
    animation.animate(layer).when(1000, {
      rotation: [Math.PI*2,centerX,centerY]
    }).start('ElasticOut').done(function(){
      layer.rotation[1] = 0;
      layer.rotation[2] = 0;
    }).during(function(){
      myChartLink.getZrender().refreshShapes(thiss.shapeList,function(){});
    });
  }

}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/components/enter-association-chain-graph/enter-association-chain-graph.component.ts